module.exports = __webpack_public_path__ + "img/videos.f597fa0b.jpg";